import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { get } from "lodash"
import { countryList } from "v2_actions/country"

const useStyles = makeStyles({
  containerWithSpacing: {
    marginRight: "5px",
  },
  
})

export const CurrencyValue = ({
  value,
  country,
  customStyling,
  showCents=false,
  horizontal_spacing
}) => {
  
  const classes = useStyles()
  const currency_symbol = countryList.getCurrencySymbol(country)
  
  var formatter = new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    minimumFractionDigits: showCents !== false ? 2 : 0,
    maximumFractionDigits: showCents !== false ? 2 : 0,
  })

  const formatted_currency =
        value !== null ? formatter.format(Math.abs(value) || 0) : ""

  
  return (
    <span className={`${customStyling} ${horizontal_spacing === true ? classes.containerWithSpacing : null}`}>
      {currency_symbol}
      {formatted_currency}
    </span>
  )
}
